import React, { useState } from "react";
import VerificaToken from "./VerificaToken";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

function ModalAggiungiPatente() {
  let history = useHistory();

  const { user, setUser } = VerificaToken();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const gestisciPatente = () => {
    axios
      .put(
        `https://website-8bit-motors.herokuapp.com/account/info/${user.id}/rimuoviPatente`
      )
      .then((response) => {
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/account/info/${user.id}`
          )
          .then((res) => {
            setShow(false);
            setUser(res.data);
            history.push(`/account/info/${user.id}/aggiungiPatente`);
          });
      }).catch(() => {
        alert("Connessione Non Disponibile");
      });;
  };

  if (!user.codicePatente) {
    return (
      <>
        <Link to={`/account/info/${user.id}/aggiungiPatente`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-card-list"
            viewBox="0 0 16 16"
          >
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
          </svg>
          <h3>Aggiungi Patente</h3>
          <p>Clicca qui per inserire una nuova patente</p>
        </Link>
      </>
    );
  } else {
    return (
      <>
        <Link onClick={handleShow}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-card-list"
            viewBox="0 0 16 16"
          >
            <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
            <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zM4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
          </svg>
          <h3>Aggiungi Patente</h3>
          <p>Clicca qui per inserire una nuova patente</p>
        </Link>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Patente già presente</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Hai già inserito una patente, per inserirne una nuova rimuovi quella
            precedente!
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No grazie.
            </Button>
            <Button variant="primary" onClick={gestisciPatente}>
              Rimuovi patente
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default ModalAggiungiPatente;
